import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Footer } from './Footer';
import { Navbar } from './Navbar';
import { Seo } from './Seo';

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="shell">
      <a className="skip-link" href="#main">
        İçeriğe geç
      </a>
      <Seo />
      <Navbar />
      <main id="main" className="main">
        {children}
      </main>
      <Footer />
    </div>
  );
};
